import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from "moment";

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Badge from '@material-ui/core/Badge';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';

import { connect } from 'react-redux';
import { compose } from "recompose";

const formatter1 = 'YYYY-MM-DD';

const styles = theme => ({
    Content: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    button: {
        margin: theme.spacing.unit,
    },
    paper: {
        position: 'absolute',
        width: '60%',
        [theme.breakpoints.down('sm')]: {
            width: '80%',
            overflow: 'scroll',
        },
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    textField: {
        width: '90%',
        margin: theme.spacing.unit,
    },
    //RadioGroup
    formControl: {
        margin: theme.spacing.unit,
    },
    group: {
        flexDirection: 'row',
    },
    root: {
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        width: 'auto',
        height: 'auto',
    },
    margin: {
        marginLeft: -(theme.spacing.unit * 4),
        marginTop: theme.spacing.unit * 3,
    },
    tabPaper: {
        flexGrow: 1,
        borderRadius: '5px',
        display: 'flex',
        flexWrap: 'wrap',
        boxShadow: '0px 3px 5px 0px rgba(0, 0, 0, 0.2)',
        marginBottom: '20px'
    },
    setMarginTop: {
        marginTop: `${theme.spacing.unit * 3}px`,
        margin: `${theme.spacing.unit}px`,
    },
    setMarginBottom: {
        marginBottom: `${theme.spacing.unit * 3}px`,
    },
    padding: {
        padding: `0 ${theme.spacing.unit * 2}px`,
    },
});

class OptionsBar extends Component {
    constructor(props) {
        super(props);
        var now = new Date();
        var dateTime = moment(now).format(formatter1);

        this.state = {
            open: false,
            tasksOpen: false,
            date: dateTime,
            tabValue: 1,
            detailTimesheetOpen: false,
        };

        this.handleSelectedDateChange = this.handleSelectedDateChange.bind(this);
    }

    handleSelectedDateChange = name => event => {
        this.setState({
            selectedDate: event.target.value
        })
        this.props.handleSelectedDateChange(event.target.value)
    }

    handleTabsChange = (event, value) => {
        this.setState({
            tabValue: value
        });
        this.props.handleTabsChange(value)
    };

    handleDatetimeTypeChange = name => event => {
        this.props.handleDatetimeTypeChange(event.target.value)
    }

    render() {
        const { classes, user } = this.props;

        return (
            <Paper square className={classes.tabPaper}>
                <TextField
                    id="date"
                    placeholder="Selected Date"
                    type="date"
                    defaultValue={this.state.date}
                    className={classes.textField}
                    style={{ width: '160px', color: '#ffffff' }}
                    onChange={this.handleSelectedDateChange('selectedDate')}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />

                <RadioGroup
                    row
                    aria-label="TaskType"
                    name="taskType"
                    className={classes.group}
                    value={this.props.datetimeType}
                    onChange={this.handleDatetimeTypeChange('datetimeType')}
                >
                    <FormControlLabel value="daily" control={<Radio />} label="Daily" />
                    <FormControlLabel value="weekly" control={<Radio />} label="Weekly" />
                    <FormControlLabel value="monthly" control={<Radio />} label="Monthly" />
                </RadioGroup>

                <Tabs
                    value={this.state.tabValue}
                    onChange={this.handleTabsChange}
                    fullWidth
                    indicatorColor="secondary"
                    textColor="secondary"
                >
                    <Tab label={user.departmentId + " - Team Timesheet"} />
                    <Tab label={"My Timesheeet"} />
                    <Tab disabled label={<Badge badgeContent={Number(workingHoursCount(this.props.data, this.state.selectedDate, user.id))} className={classes.padding} color="secondary">Working Hours</Badge>} />
                </Tabs>
            </Paper>
        );
    }
}

function workingHoursCount(data, selectedDate, id) {
    var count = 0;
    data && data.map(element => {
        count += Number(element.Hours);
        count += Number(element.HoursOvertime);

        return null
    })

    return count
}

function mapStateToProps(state) {
    const { user } = state.authentication;

    return {
        user
    };
}

OptionsBar.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles, { withTheme: true }))(OptionsBar);


// WEBPACK FOOTER //
// ./src/components/Timesheet/OptionsBar.js